// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"38":"b86c5871","72":"f91211ce","132":"704cb0ce","239":"9535bc0b","279":"b28ba088","738":"0dec52d5"}[chunkId] + ".css";
};